// Ликвидатор-эксперт (deus_likvidator_ekspert, rare, kw=stealth) — TRIGGER.
// xlsx: «Получает +1 атаки за каждого союзного юнита».
//
// А.4.5-fix5: семантика — триггер при появлении ДРУГОГО союзного юнита.
// Эксперт-в-стелсе получает +1 атаки за КАЖДОГО союзника, появившегося ПОСЛЕ
// его собственного размещения. Союзники, уже стоявшие на поле в момент призыва
// эксперта, НЕ учитываются. Самопризыв эксперта НЕ даёт ему +1.
//
// При выходе из стелса (после собственной атаки) — триггер больше не срабатывает,
// накопленный bonus «застывает». При смерти союзника бонус НЕ пересчитывается.
//
// History:
//   - fix4: добавлен self-фильтр в цикле, но логика самосрабатывания была размыта.
//   - fix4-retry / fix4-retry2: пробовали динамический recompute (Вариант А).
//     Юзер вернулся к чистому триггеру (Вариант Б) — это та модель.

import { hasKeyword, KW } from '../../keywords.js';

export const CARD_ID = 'deus_likvidator_ekspert';

// Хук «появился союзник на стороне ownerIdx»: каждому Ликвидатору-эксперту-в-стелсе,
// кроме самого summonedCard, +1 атаки и +1 к likvidatorEkspertBonus.
export function likvidatorEkspertOnAllySummon(state, ownerIdx, summonedCard) {
  const p = state.players[ownerIdx];
  if (!p || !summonedCard) return;
  for (const u of p.unitsOnField()) {
    if (u.id !== CARD_ID) continue;
    if (u === summonedCard) continue;             // не сам себе
    if (!hasKeyword(u, KW.STEALTH)) continue;     // вне стелса не растёт
    u.current.atk += 1;
    u.likvidatorEkspertBonus = (u.likvidatorEkspertBonus || 0) + 1;
    state.log.add(`👁 Ликвидатор-эксперт [${p.name}]: появился ${summonedCard.name_ru} → +1 атаки (atk=${u.current.atk})`);
  }
}
